var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPlaced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 74,
    viewBox: "0 0 149 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251102",
    d: "M84.5 72.8398L147.72 72.8398",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251103",
    d: "M0.931641 72.8398L32.8709 72.8398",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41298",
    x: 40.6289,
    y: 7.42969,
    width: 52.1254,
    height: 65.7234,
    rx: 4,
    fill: "white",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41299",
    opacity: 0.5,
    x: 44.9316,
    y: 11,
    width: 43,
    height: 57,
    rx: 4,
    fill: "#BABFFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.139 5.16406C61.6645 2.57861 63.9506 0.632812 66.6912 0.632812C69.4318 0.632812 71.7179 2.57861 72.2434 5.16406H77.4231C79.6323 5.16406 81.4231 6.95492 81.4231 9.16406V14.2294H51.9609V9.16406C51.9609 6.95492 53.7518 5.16406 55.9609 5.16406H61.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.139 5.16406V5.66406H61.5476L61.629 5.26365L61.139 5.16406ZM72.2434 5.16406L71.7534 5.26365L71.8348 5.66406H72.2434V5.16406ZM81.4231 14.2294V14.7294H81.9231V14.2294H81.4231ZM51.9609 14.2294H51.4609V14.7294H51.9609V14.2294ZM61.629 5.26365C62.1081 2.90657 64.1931 1.13281 66.6912 1.13281V0.132812C63.7082 0.132812 61.2209 2.25065 60.649 5.06447L61.629 5.26365ZM66.6912 1.13281C69.1893 1.13281 71.2743 2.90657 71.7534 5.26365L72.7334 5.06447C72.1615 2.25065 69.6742 0.132812 66.6912 0.132812V1.13281ZM72.2434 5.66406H77.4231V4.66406H72.2434V5.66406ZM77.4231 5.66406C79.3561 5.66406 80.9231 7.23107 80.9231 9.16406H81.9231C81.9231 6.67878 79.9084 4.66406 77.4231 4.66406V5.66406ZM80.9231 9.16406V14.2294H81.9231V9.16406H80.9231ZM81.4231 13.7294H51.9609V14.7294H81.4231V13.7294ZM52.4609 14.2294V9.16406H51.4609V14.2294H52.4609ZM52.4609 9.16406C52.4609 7.23107 54.0279 5.66406 55.9609 5.66406V4.66406C53.4757 4.66406 51.4609 6.67878 51.4609 9.16406H52.4609ZM55.9609 5.66406H61.139V4.66406H55.9609V5.66406Z",
    fill: "#383434"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251100",
    d: "M52.5293 24.4297H80.2918",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251104",
    d: "M52.5293 33.1914H80.2918",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251105",
    d: "M52.5293 41.9648H69.3946",
    stroke: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlaced);
export default __webpack_public_path__ + "static/media/orderPlaced.0bf1d58d217283c6b878c9e0475a3e85.svg";
export { ForwardRef as ReactComponent };